/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNavContent_viewer = {
    readonly isMessageCenterEnabled: boolean | null;
    readonly " $refType": "AccountNavContent_viewer";
};
export type AccountNavContent_viewer$data = AccountNavContent_viewer;
export type AccountNavContent_viewer$key = {
    readonly " $data"?: AccountNavContent_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountNavContent_viewer",
  "selections": [
    {
      "alias": "isMessageCenterEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'd41778817c1cf35959f2bd8b8a5e5255';
export default node;
